import { FC } from 'react'
import { AppImage, AppText, AppTitle } from '@/shared/ui'
import { cardContainerStyles } from './AuthHeader.styles'

interface AuthHeaderProps {
  cardContainerStyle?: React.CSSProperties
  imageUrl?: string
  imageStyle?: React.CSSProperties
  title?: string
  titleStyle?: React.CSSProperties
  description?: string
  descriptionStyle?: React.CSSProperties
}

const AuthHeader: FC<AuthHeaderProps> = ({
  cardContainerStyle = cardContainerStyles,
  imageUrl,
  title,
  description,
  descriptionStyle,
  imageStyle,
  titleStyle
}) => {
  return (
    <div style={cardContainerStyle}>
      {imageUrl && <AppImage style={imageStyle} src={imageUrl} />}
      {title && (
        <AppTitle style={titleStyle} level={3}>
          {title}
        </AppTitle>
      )}
      {description && <AppText style={descriptionStyle}>{description}</AppText>}
    </div>
  )
}

export default AuthHeader
